import { Observable } from 'rxjs';
import { UpdateSummaryResponse } from '../models/update-summary-response.model';

export abstract class UpdateSummaryRepository {
    abstract getUpdateSummary(): Observable<UpdateSummaryResponse>;
}
